import { Link } from 'gatsby';
import React from 'react';
import uuid from 'react-uuid';
import './title-divided-with-description.scss';

function TitleDividedWithDescription({ title, items, link, extraContentClassName = '', style, children }) {
  const mainContent = (
    <div className={`title-divided-with-description-content${extraContentClassName}`}>
      <header className='heading'>
        <h2 className='light-bold' style={style} dangerouslySetInnerHTML={{ __html: title }} />
        {items.map(item => {
          return <p key={`title-divided-with-description-content-${uuid()}`}>{item}</p>;
        })}
        {link && (
          <Link to={link.cta_url} type='button' className='button button--primary'>
            {link.placeholder}
          </Link>
        )}
      </header>
      {children}
    </div>
  );
  return mainContent;
}

export default TitleDividedWithDescription;
